<dx-slider [min]="min" [max]="max" [(value)]="value"
  (valueChange)="onSelfChangeValue(value);"
  (onFocusIn)="(!!onFocusIn && onFocusIn())" (onFocusOut)="(!!onFocusOut && onFocusOut())">
  <dxo-tooltip *ngIf="!!tooltip"
    [enabled]="!!tooltip.enabled"
    [format]="tooltip.format"
    [showMode]="tooltip.showMode"
    [position]="tooltip.position"
  ></dxo-tooltip>
</dx-slider>